import { render } from "./App.vue?vue&type=template&id=49621e0e"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Volumes/Projects/wp_lab/wp-content/plugins/debug-log-config-tool-x/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49621e0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49621e0e', __exports__)) {
    console.log('reload')
    api.reload('49621e0e', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=49621e0e", () => {
    console.log('re-render')
    api.rerender('49621e0e', render)
  })

}


export default __exports__